import { defineRule, configure } from 'vee-validate'
import { email, numeric, required, size, url } from '@vee-validate/rules'
import { setLocale, localize } from '@vee-validate/i18n'

defineRule('email', email)
defineRule('max_files', (value, [limit]) => {
  return Array.isArray(value) && value.length <= limit
})
defineRule('numeric', numeric)
defineRule('required', required)
defineRule('size', size)
defineRule('url', url)

const ro = {
  code: 'ro',
  messages: {
    _default: 'Acest câmp nu este valid.',
    alpha: 'Acest câmp poate conține doar literele alfabetului.',
    alpha_dash: "Acest câmp poate conține litere și caracterele '-' sau '_'",
    alpha_num: 'Acest câmp poate conține doar caractere alfanumerice.',
    alpha_spaces: 'Acest câmp poate conține literele și spații.',
    between: 'Valoarea acestui câmp trebuie să fie între 0:{min} și 1:{max}.',
    confirmed: 'Acest câmp nu coincide.',
    digits:
      'Acest câmp trebuie să fie numeric și să conțină exact 0:{length} caractere.',
    dimensions:
      'Acest câmp trebuie să fie 0:{width} pixeli lungime și 1:{height} pixeli înălțime.',
    email: 'Acest câmp trebuie să conțină un email valid.',
    not_one_of: 'Acest câmp trebuie să conțină o valoare validă.',
    ext: 'Acest câmp trebuie să fie un nume de fișier valid.',
    image: 'Acest câmp trebuie să fie o imagine.',
    one_of: 'Acest câmp trebuie să conțină o valoare validă.',
    max: 'Acest câmp nu poate avea mai mult de 0:{length} caractere.',
    max_files: 'Acest câmp nu poate conține mai mult de 0:{length} fișiere.',
    max_value: 'Valoarea acestui câmp trebuie să fie maxim 0:{max}.',
    mimes: 'Acest câmp trebuie să conțină un fișier cu extensie validă.',
    min: 'Acest câmp trebuie să conțină cel puțin 0:{length} caractere.',
    min_value: 'Valoarea acestui câmp trebuie să fie mai mare de 0:{min}.',
    numeric: 'Acest câmp poate conține doar valori numerice.',
    regex: 'Formatul acestui câmp este invalid.',
    required: 'Acest câmp este obligatoriu.',
    required_if: 'Acest câmp este obligatoriu.',
    size: 'Dimensiunea fișierului trebuie să nu depășească 0:{size}KB.',
    url: 'Acest câmp nu conține un URL valid.',
  },
}

const en = {
  code: 'en',
  messages: {
    _default: 'This field is not valid.',
    alpha: 'This field may only contain alphabetic characters.',
    alpha_num: 'This field may only contain alpha-numeric characters.',
    alpha_dash:
      'This field may contain alpha-numeric characters as well as dashes and underscores.',
    alpha_spaces:
      'This field may only contain alphabetic characters as well as spaces.',
    between: 'This field must be between 0:{min} and 1:{max}.',
    confirmed: 'This field confirmation does not match.',
    digits: 'This field must be numeric and exactly contain 0:{length} digits.',
    dimensions: 'This field must be 0:{width} pixels by 1:{height} pixels.',
    email: 'This field must be a valid email.',
    not_one_of: 'This field is not a valid value.',
    ext: 'This field is not a valid file.',
    image: 'This field must be an image.',
    integer: 'This field must be an integer.',
    length: 'This field must be 0:{length} long.',
    max_value: 'This field must be 0:{max} or less.',
    max: 'This field may not be greater than 0:{length} characters.',
    max_files: 'This field may not contain more than 0:{length} files.',
    mimes: 'This field must have a valid file type.',
    min_value: 'This field must be 0:{min} or more.',
    min: 'This field must be at least 0:{length} characters.',
    numeric: 'This field may only contain numeric characters.',
    one_of: 'This field is not a valid value.',
    regex: 'This field format is invalid.',
    required_if: 'This field is required.',
    required: 'This field is required.',
    size: 'File size must be less than 0:{size}KB.',
    url: 'This field is not a valid URL.',
  },
}

configure({
  validateOnModelUpdate: false,
  generateMessage: localize({
    ro,
    en,
  }),
})

setLocale(document.documentElement.lang)
